import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ApiService } from "../services";

export function useDeleteAddressMutation() {
  const queryClient = useQueryClient();
  const user = useSelector((state) => state.user);

  return useMutation({
    mutationFn: async (id) => {
      const response = await ApiService.delete(`address/${id}`, {
        authorization: `Bearer ${user.authToken}`
      });

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["addresses", user.authToken]
      });
    }
  });
}

export function useAddAddressMutation() {
  const queryClient = useQueryClient();
  const user = useSelector((state) => state.user);

  return useMutation({
    mutationFn: async (address) => {
      const rtoken = await window.grecaptcha.execute(
        "6Ld7kTkpAAAAABdexIPX64wyeOA8ahksUySyZ1Ch",
        { action: "addAddress" }
      );
      const response = await ApiService.post(
        "address",
        { ...address },
        {
          authorization: `Bearer ${user.authToken}`,
          "bot-token": rtoken
        }
      );

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["addresses", user.authToken]
      });
    }
  });
}
